(function ($) {
  'use strict';

  window.gtmSyneriseLoaded = window.gtmSyneriseLoaded || false;

  var formValues = {};
  var $form;

  function sendSyneriseData(values) {
    if (
      values.fullName &&
      values.email &&
      typeof SR !== 'undefined' &&
      typeof SR.event !== 'undefined' &&
      typeof SR.event.track === 'function'
    ) {
      SR.event.track('WLC Contact form success', {
        fullName: values.fullname,
        email: values.email,
        message: values.message ? values.message : '',
      });
    }
  }

  // CALLBACK reCAPTCHA
  window.onRecaptchaSuccess = function () {
    var postData =
      $.param({ action: 'send_contact_form' }) + '&' + $form.serialize();
    var $button = $form.find('button');
    var $disabled = $('input,select,textarea', $form);
    $disabled.add($button);
    $disabled.attr('disabled', 'disabled');
    $button.addClass('loading');

    $('div.alert')
      .removeClass('alert-warning alert-error alert-info alert-success')
      .slideUp();
    $form
      .prev('div.alert')
      .removeClass('alert-warning alert-error alert-info alert-success')
      .slideUp();

    $.ajax({
      method: 'POST',
      url: window.ys.ajax_url,
      data: postData,
      dataType: 'json',
      success: function (response) {
        if (response.status === 'success') {
          $form.prev('div.alert').addClass('alert-success');
          $form.slideUp(function () {
            $form
              .prev('div.alert')
              .html(response.message)
              .slideDown()
              .addClass('alert-success');
            $(this).remove();
          });
          if (typeof window.dataLayer !== 'undefined') {
            window.dataLayer.push({
              event: 'gaEvent',
              eventCategory: 'form',
              eventAction: 'submit',
              eventLabel: 'contact us',
              NonInteractive: false,
            });
          }
          if (window.gtmSyneriseLoaded) {
            sendSyneriseData(formValues);
          } else {
            document.addEventListener('gtm.synerise.loaded', function () {
              sendSyneriseData(formValues);
            });
          }
        } else {
          $form
            .prev('div.alert')
            .html(response.message)
            .slideDown()
            .addClass('alert-warning');
          if (typeof response.data !== 'undefined') {
            $.each(response.data, function (name) {
              $(
                'input[name="' + name + '"], textarea[name="' + name + '"]',
                $form
              )
                .prev('div.alert')
                .html(this)
                .slideDown()
                .addClass('alert-error');
            });
          }
        }
      },
      complete: function () {
        $disabled.attr('disabled', false);
        $button.removeClass('loading');
      },
    });
  };

  $(document).on('submit', '#contact-form', function (e) {
    e.preventDefault();
    $form = $(this);
    formValues = {};
    $.each($form.serializeArray(), function (i, field) {
      formValues[field.name] = field.value;
    });

    if (typeof grecaptcha !== 'undefined') {
      grecaptcha.execute();
    } else {
      console.error('reCAPTCHA not loaded.');
    }
  });
}).bind(window)(jQuery);
